function eventEmitter(target) {
  return (options) => {
    const { type, eventOptions, callback } = options;
    const event = new CustomEvent(type, {
      bubbles: true,
      cancelable: callback instanceof Function ? true : false,
      composed: true,
      detail: {},
      ...eventOptions
    });
    target.dispatchEvent(event);
    if (callback instanceof Function) {
      if (!event.defaultPrevented) {
        callback.call(target);
      }
    }
  };
}
export {
  eventEmitter
};
//# sourceMappingURL=event-helpers.js.map
